module.exports = __webpack_public_path__ + "static/media/35import.68acd604.xlsx";